import type { FC } from 'react';
import React from 'react';

import { Box, Flex, Text, xcss } from '@atlaskit/primitives';

const BORDER_RADIUS = 'border.radius.050';

const totalBarStyles = xcss({
	height: '4px',
	borderRadius: BORDER_RADIUS,
	marginBottom: 'space.050',
});

const playedBarStyles = xcss({
	height: '100%',
	borderRadius: BORDER_RADIUS,
});

type AudioProgressBarProps = {
	progress: number;
	currentTime: number;
	totalTime: number;
};

export const AudioProgressBar: FC<AudioProgressBarProps> = ({
	progress,
	currentTime,
	totalTime,
}) => {
	const formatTime = (timeInSeconds: number) => {
		const minutes = Math.floor(timeInSeconds / 60);
		const seconds = Math.floor(timeInSeconds % 60);
		return `${minutes}:${seconds.toString().padStart(2, '0')}`;
	};

	return (
		<Box>
			<Box backgroundColor="color.background.accent.gray.subtler" xcss={totalBarStyles}>
				<Box
					testId="current-progress-bar"
					backgroundColor="color.background.brand.bold"
					xcss={playedBarStyles}
					style={{ width: `${progress * 100}%` }}
				/>
			</Box>
			<Flex justifyContent="space-between">
				<Text size="small" color="color.text.subtle" weight="semibold">
					{formatTime(currentTime)}
				</Text>
				<Text size="small" color="color.text.subtle" weight="semibold">
					{formatTime(totalTime)}
				</Text>
			</Flex>
		</Box>
	);
};
